export enum SupportedChainId {
    MAINNET = 1,
    ROPSTEN = 3,
    RINKEBY = 4,
    GOERLI = 5,
    KOVAN = 6,
    POLYGON = 137,
    BINANCE = 56,
    BINANCETEST = 97,
    POLYGONTEST = 80001,
    OASISTEST = 42261,
    OASISMAINNET = 42262,
  }
  
  export const ALL_SUPPORTED_CHAIN_IDS: SupportedChainId[] = [
    SupportedChainId.MAINNET,
    SupportedChainId.BINANCE,
    SupportedChainId.POLYGON,
  
    SupportedChainId.POLYGONTEST,
    SupportedChainId.BINANCETEST,
    SupportedChainId.ROPSTEN,
    SupportedChainId.RINKEBY,
    SupportedChainId.GOERLI,
    SupportedChainId.KOVAN,
    SupportedChainId.OASISTEST,
    SupportedChainId.OASISMAINNET,
  ];